<template>
    <div class="control has-addons flatpickr form-horizontal row clearfix" data-wrap="true" data-clickOpens="false"
       :class="{ [`has-addons-${alignment}`]: alignment }">
            <div class="col-xs-10">
                <input class="input form-control" :class="inputClass" type="text" :placeholder="placeholder"
                       :readonly="readonly" v-model="date" data-input data-toggle />
            </div>
            <div class="col-xs-2">
                <a class="input-button" :title="clearTooltip" data-clear>
                    <i class="glyphicon glyphicon-remove"></i>
                </a>
            </div>
        <slot></slot>
    </div>
</template>

<script>
    import BaseInput from './BaseInput'

    export default {
        mixins: [BaseInput],
        props: {
            readonly: Boolean
        }
    }
</script>

<style scoped>
    .form-control {
        width: 100%;
        float: left;
        cursor: pointer;
    }

    .input-button {
        display: inline-block;
        float: left;
        height: 34px;
        width: 100%;
        border: 1px solid #ccc;
        border-radius: 4px;
        cursor: pointer;
    }

    .input-button i {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin-top: -5px;
        color: #aaa;
    }

    div[class^=col-xs-] {
        display: block;
        padding: 0 5px;
    }

    .row {
        margin-left: -5px;
        margin-right: -5px;
    }
</style>

<style>

    .flatpickr-calendar {
        max-height: 640px;
    }

    .flatpickr-calendar.static.arrowBottom {
        top: auto;
        bottom: calc(100% + 10px);
    }

    .flatpickr-calendar .close-wrapper {
        height: 40px;
        border-top: 1px solid #e6e6e6;
        cursor: pointer;
    }

    .flatpickr-calendar .close-wrapper:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .flatpickr-calendar .close-wrapper a {
        display: inline-block;
        line-height: 40px;
        width: 100%;
        color: #333;
    }
</style>



// WEBPACK FOOTER //
// WrapperInput.vue?4546d67f